export const RESET_UNITS_DATATABLE = 'RESET_UNITS_DATATABLE';
export const SET_CURRENT_UNITS_PAGE = 'SET_CURRENT_UNITS_PAGE';
export const SET_NUMBER_OF_UNITS_TO_SHOW_PER_PAGE = 'SET_NUMBER_OF_UNITS_TO_SHOW_PER_PAGE';